import { render, staticRenderFns } from "./product_8_sw.vue?vue&type=template&id=132458ab&scoped=true"
import script from "./product_8_sw.vue?vue&type=script&lang=js"
export * from "./product_8_sw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132458ab",
  null
  
)

export default component.exports